import { Button } from "@/components/ui/button";
import { ArrowRight, Upload, Zap } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative min-h-screen gradient-hero pt-24 pb-16 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/10 rounded-full blur-3xl" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-8 animate-slide-up">
            <Zap className="w-4 h-4" />
            <span>AI-Powered Study Assistant</span>
          </div>
          
          {/* Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-foreground mb-6 leading-tight animate-slide-up animation-delay-100">
            Turn Your Notes Into
            <span className="text-gradient block mt-2">Assignment Gold</span>
          </h1>
          
          {/* Subheading */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 animate-slide-up animation-delay-200">
            Upload a photo of your handwritten notes. Get clean text, assignment answers, PPTs, 
            explanations & more — all powered by AI. Study smarter, not harder.
          </p>
          
          {/* Free Credits Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-green-500/15 text-green-600 dark:text-green-400 text-base font-semibold mb-6 animate-slide-up animation-delay-250 border border-green-500/30">
            <span className="text-xl">🎁</span>
            <span>Get 3 Free Credits — No Card Required!</span>
          </div>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 animate-slide-up animation-delay-300">
            <Button variant="hero" size="xl" className="w-full sm:w-auto">
              <Upload className="w-5 h-5" />
              Start Free Now
            </Button>
            <Button variant="outline" size="xl" className="w-full sm:w-auto">
              See How It Works
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 max-w-lg mx-auto animate-slide-up animation-delay-400">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-foreground">50K+</div>
              <div className="text-sm text-muted-foreground">Students</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-foreground">1M+</div>
              <div className="text-sm text-muted-foreground">Notes Processed</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-foreground">4.9★</div>
              <div className="text-sm text-muted-foreground">Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
